<div class="flex flex-col gap-2">
    <input type="text" class="search-field" placeholder="nach Material suchen" #searchString (keyup)="searchString$.next(searchString.value)" />
    <div class="scroll-wrapper flex flex-col gap-2">
        <div class="grid custom-grid gap-4 items-center">
            <div></div>
            <div class="font-bold">Typ</div>
            <div class="font-bold">{{(cls.getLabels$('Commission') | async)?.wordBinding}}nummer</div>
            <div class="font-bold">Nummer</div>
            <div class="font-bold">Artikelname</div>
            <div class="font-bold">Anzahl</div>
            <div class="font-bold">Lager</div>
            <div class="font-bold">Einh.</div>
            <div></div>
        </div>
        <ng-container *ngFor="let materialListItem of materialListFiltered$ | async">
            <div
                class="grid custom-grid gap-4 items-center border border-color"
                [class.disabled]="materialListItem.disabled"
                [class.red]="materialListItem.warn$ | async"
                [class]="materialListItem.colorClass$ | async"
                *ngIf="!materialListItem.hide"
            >
                <div><fa-icon [class.disabled]="materialListItem.disabled" *ngIf="materialListItem.warn$ | async as icon" icon="triangle-exclamation" class="ml-4 color red" matTooltip="kein Material"></fa-icon></div>
                <div>{{materialListItem.warehouseMovementTypeLabel}}</div>
                <div>
                    <ng-container *ngIf="materialListItem.commission$ | async as commission; else notFound;">
                        {{commission.Auftragsnummer}}
                    </ng-container>
                    <ng-template #notFound>
                        <ng-container *ngIf="materialListItem.detectedCommissionNumber">
                            {{ materialListItem.detectedCommissionNumber }} <fa-icon [matTooltip]="(cls.getLabels$('Commission') | async)?.wordBinding + 'nummer unbekannt'" icon="triangle-exclamation"></fa-icon>
                        </ng-container>
                    </ng-template>
                </div>
                <div class="three-line">{{ materialListItem.number }}</div>
                <div *ngIf="!materialListItem.arlId; else name">
                    <mat-form-field class="w-full">
<!--                        <app-select-search [formControl]="materialListItem.quantityFormGroup.controls.materialId" [Options]="materialOptions$ | async" [CompareOptions]="compareById"></app-select-search>-->
                        <app-select-search-paged-options
                            #pagedSelect
                            [placeholder]="MaterialEntity.EntityName"
                            [formControl]="materialListItem.quantityFormGroup.controls.materialId"
                            [Options]="materialOptions$ | async"
                            [CompareOptions]="compareById"
                            (searchChange)="materialOptionsSearchChange($event, paginator)"
                            required
                            [OptionTemplate]="optionTemplate"
                            (opened)="materialOptionsSearchChange(pagedSelect.searchForm.value, paginator)"
                        >
                            <mat-paginator option-list-footer #paginator [pageSize]="pageSize$ | async" [length]="_materialPageService.selectLength$ | async" (page)="materialOptionsPageChange($event)"></mat-paginator>
                        </app-select-search-paged-options>
                    </mat-form-field>
                    <ng-template #optionTemplate let-option>
                        {{ option.DisplayName }}
                    </ng-template>
                </div>
                <ng-template #name
                    ><div class="three-line">{{ materialListItem.name }}</div></ng-template
                >
                <div class="flex gap-1">
                    <input class="grow width-4" matInput type="number" placeholder="Anzahl" [formControl]="materialListItem.quantityFormGroup.controls.quantity" />
                    <span>/</span>
                    <span class="grow width-0">{{ materialListItem.quantityTarget }}</span>
                </div>
                <div>{{ materialListItem.quantityFromWarehouse }}</div>
                <div>{{ materialListItem.quantityType }}</div>
                <div class="flex justify-end">
                    <ng-container *ngIf="!materialListItem.disabled">
                        <button mat-icon-button class="font-size-1-5" matTooltip="Material anlegen" *ngIf="!materialListItem.quantityFormGroup.controls.materialId.getRawValue()" (click)="createMaterial(materialListItem)">
                            <fa-icon icon="plus"></fa-icon>
                        </button>
                        <button mat-icon-button class="font-size-2" (click)="onTimesClick(materialListItem)"><fa-icon icon="times"></fa-icon></button>
                    </ng-container>
                    <ng-container *ngIf="materialListItem.disabled">
                        <button mat-icon-button class="font-size-1-5" matTooltip="löachen" color="warn" (click)="deleteMaterial(materialListItem)">
                            <fa-icon icon="trash"></fa-icon>
                        </button>
                        <button mat-icon-button class="font-size-2 dont-disable" (click)="onCheckClick(materialListItem)"><fa-icon icon="check"></fa-icon></button>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
    <button app-round-button class="ml-auto" (click)="addEmptyMaterial()" matTooltip="Artikel hinzufügen"><fa-icon icon="plus"></fa-icon></button>
</div>
<app-loading *ngIf="loading$ | async"></app-loading>
